import React from 'react';
import { Section } from './ui/Section';
import { ListChecks, FileText, RefreshCw, ShieldAlert } from 'lucide-react';
export function TheTrap() {
  const items = [{
    icon: FileText,
    text: 'un menú simple'
  }, {
    icon: ListChecks,
    text: 'una lista cerrada'
  }, {
    icon: RefreshCw,
    text: 'reemplazos cuando algo falla'
  }, {
    icon: ShieldAlert,
    text: 'un plan de emergencia cuando no cocinaste'
  }];
  return <Section data-id="element-134">
      <h2 className="text-3xl font-bold mb-6" data-id="element-135">
        La trampa: creer que necesitás más información
      </h2>

      <p className="text-lg mb-8 leading-relaxed" data-id="element-136">
        Información hay de sobra. Lo que falta es esto:
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10" data-id="element-137">
        {items.map((item, idx) => <div key={idx} className="flex items-center gap-3 p-4 bg-white rounded-xl border border-stone-100 shadow-sm" data-id="element-138">
            <item.icon className="w-5 h-5 text-amber" data-id="element-139" />
            <span className="font-medium" data-id="element-140">{item.text}</span>
          </div>)}
      </div>

      <p className="text-xl font-bold text-center text-brown-heading" data-id="element-141">
        O sea: una semana resuelta.
      </p>
    </Section>;
}